// theme.js
    //blue: '#4ec1e0',
export default {
  colors: {
    blue: '#4ec1e0',
    lightblue: '#f4fdff',
    //lightblue: '#f4fdff',
    darkblue: '#2ea2d2',
    black: '#404040',
    black1: '#333333',
    lightblack: '#898989',
    darkwhite: '#f7f7f7',
    lightgrey: '#c6c6c6',
    mediumgrey: '#f0f0f0',
    darkgrey: '#a5a5a5',
    grey1: '#f8f8f8',
    grey2: '#6c6c6c',
    white: 'white',
    red: '#ff554e',
    red1: '#ff6d67',
    green: '#76b376',
    green1: '#86d677',
    orange: '#f6934b',
    pink: '#f64b7f',
    purple: '#8a499a',

    //NEW
    LightBlue1   :'#F4FDFF', //Hover and select effects
    LightBlue2   :'#B5E0EB',  //Hover and light contrast on JibberBlue BG’s
    JibberBlue_L :'#4EC1E0', //Accent color for use on Dark BG
    JibberBlue_M :'#2EA2D2', //Accent color for use on Light BG
    JibberBlue_D :'#198CBC',
    NavyBlue_M :'#0018CC',
    JibberPink :'#F64B7F',
    JibberMint :'#00FFB1',
    JibberPurple_L :'#A25CBF',
    JibberPurple_M :'#8A499A',
    JibberYellow :'#FFBA00',
    JibberOrange :'#F6934B',
    JibberGreen_L :'#9ACD9A',
    JibberGreen_D :'#76B376',
    OnlineGreen :'#8FEF54', //Online and switch buttons.
    PositiveGreen :'#86D677', //Positive feedback/confirmations
    NegativeRed :'#FF6D67', //Negative feedback/confirmations/Warnings/Offline
    LightGray1  :'#F8F8F8', //Hover/Contrast/BGs on white
    LightGray2 :'#F0F0F0', //Hover/Contrast to Lightgrey1
    LightGray3 :'#EAEAEA',
    LightGray4 :'#E5E5E5',
    MediumGray1 :'#C6C6C6',
    MediumGray2 :'#BABABA',
    MediumGray3 :'#A5A5A5',
    MediumGray4 :'#898989', //Main medium, various use.
    MediumGray5 :'#6C6C6C',
    MediumGray6 :'#5A5A5A',
    MediumGray7 :'#4E4E4E',  //Light hover plate on DarkGray
    DarkGray :'#404040',  //Titles, icons,graphics on White bg
    Black_M :'#333333', //“Muted” black for use on small text
    Black_D :'#1D1D1D', //Substitute for #000000 (edited)
  },
  FontSize: {
      normal: '16px',
  }
}



// WEBPACK FOOTER //
// ./src/theme.js